export const API_KEY_PER_USER_LIMIT = 100;
export const NULL_COINBASE_ID = '00000000-0000-0000-0000-000000000000';
export const SELECT_OPTION_WIDTH = 320;

export const TRADE_CHECKBOX_OPTIONS = {
  view: 'View (read-only)',
  trade: 'Trade (execute trades on your behalf)',
  transfer: 'Transfer (initiate transfer of funds)',
};
